import {
    CONFIRMED_GET_PROERTY_VERIFY_LISTS,
    CONFIRMED_GET_PROERTY_VERIFY_MESSAGES
} from '../actions/propertyVerification/PropertyVerificationTypes';
const initialState = {
    propertyVerifyLists: [],
    propertyVerifyMessages: [],
    test: [],
    loading: false
};

function PropertyVerificationReducer(state = initialState, actions) {
    switch (actions.type) {
        case 'SET_PROPERTY_VERIFICATION_LOADING':
            return {
                ...state,
                loading: actions.payload,
            };
        case CONFIRMED_GET_PROERTY_VERIFY_LISTS:
            return {
                ...state,
                propertyVerifyLists: actions.payload,
                loading: false,
            };
        case CONFIRMED_GET_PROERTY_VERIFY_MESSAGES:
            return {
                ...state,
                propertyVerifyMessages: actions.payload,
            };
        default:
            return state;
    }
}

export {PropertyVerificationReducer};